import React from "react";
import { useApp } from "../context/AppContext";
import { Shell } from "../components/Shell";
import { LifeBuoy } from "lucide-react";

export default function Safety() {
    const { t } = useApp();
    return (
        <Shell eyebrow={t("nav.safety")} title="Safety & limitations" intro="Your wellbeing matters more than any product. Please read this.">
            <div className="rounded-2xl bg-forest text-ivory p-6 sm:p-8 flex gap-4" data-testid="safety-banner">
                <LifeBuoy className="shrink-0 text-gold" />
                <p className="leading-relaxed">{t("safety.banner")}</p>
            </div>
            <div className="mt-8 space-y-5 text-charcoal/80 leading-relaxed">
                <p><strong className="text-forest">WHY-AM is not emergency care.</strong> It is a self-reflection tool and not a substitute for diagnosis, therapy, or crisis support from a qualified professional.</p>
                <p><strong className="text-forest">If you are in India</strong>, you can reach the national mental health helpline <strong>Tele-MANAS at 14416</strong> (or 1800-891-4416), available 24/7. If you are elsewhere, please search for your local emergency number or crisis line.</p>
                <p>Safety guidance is never placed behind payment. The AI companion will always encourage you toward real human and professional support when it matters, and it cannot monitor emergencies.</p>
                <p>WHY-AM does not diagnose conditions, promise relationship or life outcomes, or claim certainty about anyone's hidden intentions.</p>
            </div>
        </Shell>
    );
}
